import { useLazyQuery } from './useLazyQuery'

const useLazyQueryNoCache = (query, options) => useLazyQuery(query, { fetchPolicy: 'no-cache', ...options })

export { useLazyQueryNoCache }
